import { connectedAccountsStore } from '../store/store';
import { ConnectionType } from '../store/schema/ConnectionType';
export function getErrorConnectAdvanced() {
    var store = connectedAccountsStore();
    var hasIncomingServerError = false;
    var hasIncomingPortError = false;
    var hasOutgoingServerError = false;
    var hasOutgoingPortError = false;
    if (store.connectAdvancedState.connectionType === ConnectionType.ImapSmtp) {
        hasIncomingServerError = store.connectAdvancedState.imapServer === '';
    }
    else if (store.connectAdvancedState.connectionType === ConnectionType.PopSmtp) {
        hasIncomingServerError = store.connectAdvancedState.popServer === '';
    }
    if (store.connectAdvancedState.connectionType !== ConnectionType.SmtpOnly) {
        hasIncomingPortError =
            store.connectAdvancedState.incomingPort === '' ||
                isNaN(parseInt(store.connectAdvancedState.incomingPort));
    }
    if (store.connectAdvancedState.remoteSend) {
        hasOutgoingServerError = store.connectAdvancedState.smtpServer === '';
    }
    if (store.connectAdvancedState.remoteSend === true) {
        hasOutgoingPortError =
            store.connectAdvancedState.outgoingPort === '' ||
                isNaN(parseInt(store.connectAdvancedState.outgoingPort));
    }
    return (store.connectAdvancedState.emailAddress === '' ||
        store.connectAdvancedState.password === '' ||
        hasIncomingServerError ||
        hasIncomingPortError ||
        hasOutgoingServerError ||
        hasOutgoingPortError ||
        (store.connectAdvancedState.useAltUsernamePassword &&
            store.connectAdvancedState.altPassword === ''));
}
//# sourceMappingURL=getErrorConnectAdvanced.js.map